
import { httpV2 } from "@/api/index";

/**
* Obtem versão atual do back-end.
*/
const GetBackendVersion = function()
{
	return httpV2.get("/SystemVersions");
};

export default { GetBackendVersion, };
